import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ServicesService } from 'src/app/shared/services/services.service';
import { ViewportService } from 'src/app/shared/services/viewport.service';
import { RelatedServiceInterface } from 'src/app/shared/interfaces/related-service.interface';
import { dividerBackgroundColor } from 'src/app/shared/types/divider-background-color.type';

@Component({
  selector: 'app-related-services',
  templateUrl: './related-services.component.html',
  styleUrls: ['./related-services.component.scss']
})
export class RelatedServicesComponent implements OnInit {
  @Output() navigateEvent = new EventEmitter();
  private isDesktopSubscription: Subscription;
  public isDesktop: boolean;
  public readonly dividerBackgroundColor: dividerBackgroundColor = 'background-darker';
  public relatedServices: RelatedServiceInterface[] = [];
  public error: any;
  public hasError: boolean;

  constructor(
    private router: Router,
    private servicesService: ServicesService,
    private viewportService: ViewportService
  ) {}

  ngOnInit(): void {
    this.isDesktopSubscription = this.viewportService.isDesktopObservable.subscribe((value) => {
      this.isDesktop = value;
    });
    this.getRelatedServices();
  }

  private async getRelatedServices() {
    try {
      const serviceId = parseInt(this.router.url.split('/').find((element) => !isNaN(parseInt(element))));

      this.relatedServices = await this.servicesService.getRelatedServices(serviceId);
    } catch (error) {
      this.hasError = true;

      console.error(error);
    }
  }

  public async handleRelatedServiceLinkClick(url: string) {
    await this.router.navigate([url]).then(() => {
      this.getRelatedServices();
      this.navigateEvent.emit();
    });
  }
}
